import React from "react";
import { useGetFollowingCoachesBlogs } from "../../../hooks/blogs";

type BlogPageCardsWrapperProps = React.ComponentProps<"div">;

export const BlogPageCardsFollowingWrapper = ({
  children,
}: BlogPageCardsWrapperProps) => {
  useGetFollowingCoachesBlogs();

  return <div className={"flex flex-col space-y-4"}>{children}</div>;
};
